import styled from 'styled-components';
import headerMixin from './mixins/HeaderMixin';

export default styled.h4`
  font-size: 1.414rem;
  ${headerMixin};
`;



// WEBPACK FOOTER //
// ./src/components/Typography/H4.js